import { jsx as _jsx } from "react/jsx-runtime";
import { styled, Link as MUILink, } from "@mui/material";
import { convertPxToRem } from "../../util-functions";
const handleColorVariant = (colorVariant, disabled, theme) => {
    if (disabled) {
        return {
            color: theme.palette.disabledText.main,
            textDecorationColor: theme.palette.disabledText.main,
            cursor: "none",
            // This handles the disabling of the Link
            pointerEvents: "none",
            "&:hover": {
                textDecorationColor: theme.palette.disabledText.main,
            },
        };
    }
    switch (colorVariant) {
        case "secondary":
            return {
                color: theme.palette.primaryBlackText.main,
                textDecorationColor: theme.palette.primaryBlackText.main,
                "&:hover": {
                    color: theme.palette.secondaryText.main,
                    textDecorationColor: theme.palette.secondaryText.main,
                },
            };
        case "inverted":
            return {
                color: theme.palette.primaryWhiteText.main,
                textDecorationColor: theme.palette.primaryWhiteText.main,
                "&:hover": {
                    color: theme.palette.grey06.main,
                    textDecorationColor: theme.palette.grey06.main,
                },
                "&:focus-visible": {
                    outline: `${convertPxToRem(2)} solid ${theme.palette.primaryWhite.main}`,
                },
            };
        default: // primary
            return {
                color: theme.palette.green10.main,
                textDecorationColor: theme.palette.green10.main,
                "&:hover": {
                    color: theme.palette.green09.main,
                    textDecorationColor: theme.palette.green09.main,
                },
            };
    }
};
const StyledLink = styled(MUILink, {
    shouldForwardProp: (prop) => prop !== "colorVariant" && prop !== "disabled",
})(({ theme, colorVariant, disabled }) => ({
    cursor: "pointer",
    "&.MuiLink-root": handleColorVariant(colorVariant, disabled, theme),
    "&:focus-visible": {
        outline: `${convertPxToRem(2)} solid ${theme.palette.primaryBlack.main}`,
        borderRadius: convertPxToRem(5),
    },
}));
export const Link = ({ ariaLabel, colorVariant = "primary", children, disabled = false, href, newTab = false, underline = "hover", testId, variant = "mediumTextStrong", }) => (_jsx(StyledLink, Object.assign({ "data-testid": testId, "aria-label": ariaLabel, colorVariant: colorVariant, href: href, underline: underline, variant: variant, disabled: disabled, tabIndex: 0, target: newTab ? "_blank" : undefined, rel: newTab ? "noopener" : undefined }, { children: children })));
